import { Enrollment } from '@shared/clientTypes';
import { mergeClassNames } from 'apps/agora/src/utils/helpers';
import moment from 'moment';
import SessionModalSection from '../../DetailsModalSection';

interface EnrollmentMentorHistorySectionProps {
  enrollment: Enrollment;
}

const EnrollmentMentorHistorySection = ({ enrollment }: EnrollmentMentorHistorySectionProps) => {
  const { mentorHistory, mentor } = enrollment;

  const reverseMentorHistory = [...(mentorHistory ?? [])].sort((a, b) => {
    const dateA = new Date(a.addedOn) || new Date(0);
    const dateB = new Date(b.addedOn) || new Date(0);
    return dateB.getTime() - dateA.getTime();
  });

  return (
    <SessionModalSection sectionTitle="Mentor History" className="flex flex-col gap-1">
      {/* Current Mentor */}
      {mentor?._id ? (
        <div className="flex flex-col px-2 py-1 bg-surfaceHighlight rounded">
          <div className="text-sm font-semibold text-customPrimary">
            Current Mentor: {mentor.fullName}
          </div>
          <div className="text-xs text-customGrey">
            Added on: {moment(mentor.addedOn).format('DD MMM YYYY, HH:mm')}
          </div>
        </div>
      ) : (
        <div className="text-sm text-customGrey italic px-2 mb-4">No current mentor assigned.</div>
      )}

      {/* History */}
      {reverseMentorHistory?.length ? (
        reverseMentorHistory.map((mentor, index) => (
          <div
            key={mentor.mentorId.toString()}
            className={mergeClassNames('flex flex-col px-2 py-1 bg-surfaceBackground rounded', {
              'bg-surfaceHover': index === 0,
            })}
          >
            <div className="text-sm font-semibold text-customPrimary">{mentor.fullName}</div>
            <div className="text-xs text-customGrey">
              Added on: {moment(mentor.addedOn).format('DD MMM YYYY, HH:mm')}
              {mentor.addedByName && <span> by {mentor.addedByName}</span>}
            </div>
            {mentor.removedOn && (
              <div className="text-xs text-customRedAccent">
                Removed on: {moment(mentor.removedOn).format('DD MMM YYYY, HH:mm')}
                {mentor.removedByName && <span> by {mentor.removedByName}</span>}
              </div>
            )}
          </div>
        ))
      ) : (
        <div className="text-sm text-customGrey italic px-2">No mentor history available.</div>
      )}
    </SessionModalSection>
  );
};

export default EnrollmentMentorHistorySection;
